"use strict";
/* Generated from:
 * ap-northeast-1 (https://d33vqc0rt9ld30.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-northeast-2 (https://d1ane3fvebulky.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-south-1 (https://d2senuesg1djtx.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-southeast-1 (https://doigdx0kgq9el.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ap-southeast-2 (https://d2stg8d246z9di.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * ca-central-1 (https://d2s8ygphhesbe7.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-central-1 (https://d1mta8qj7i28i2.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-1 (https://d3teyb21fexa9r.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-2 (https://d1742qcu2c1ncx.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * eu-west-3 (https://d2d0mfegowb3wk.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * sa-east-1 (https://d3c9jyj3w509b0.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-1 (https://d1uauaxba7bl26.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-east-2 (https://dnwj8swjjbsbt.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-west-1 (https://d68hl49wbnanq.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0,
 * us-west-2 (https://d201a2mn26r7lk.cloudfront.net/latest/gzip/CloudFormationResourceSpecification.json), version 39.2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
const resource_1 = require("../resource");
class InforNexusConnectorProfileProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.InforNexusConnectorProfileProperties = InforNexusConnectorProfileProperties;
class DynatraceConnectorProfileCredentials {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DynatraceConnectorProfileCredentials = DynatraceConnectorProfileCredentials;
class MarketoConnectorProfileCredentials {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.MarketoConnectorProfileCredentials = MarketoConnectorProfileCredentials;
class RedshiftConnectorProfileCredentials {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.RedshiftConnectorProfileCredentials = RedshiftConnectorProfileCredentials;
class ZendeskConnectorProfileProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ZendeskConnectorProfileProperties = ZendeskConnectorProfileProperties;
class GoogleAnalyticsConnectorProfileCredentials {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.GoogleAnalyticsConnectorProfileCredentials = GoogleAnalyticsConnectorProfileCredentials;
class DynatraceConnectorProfileProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DynatraceConnectorProfileProperties = DynatraceConnectorProfileProperties;
class SalesforceConnectorProfileCredentials {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SalesforceConnectorProfileCredentials = SalesforceConnectorProfileCredentials;
class RedshiftConnectorProfileProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.RedshiftConnectorProfileProperties = RedshiftConnectorProfileProperties;
class ConnectorProfileCredentials {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ConnectorProfileCredentials = ConnectorProfileCredentials;
class SingularConnectorProfileCredentials {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SingularConnectorProfileCredentials = SingularConnectorProfileCredentials;
class ServiceNowConnectorProfileCredentials {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ServiceNowConnectorProfileCredentials = ServiceNowConnectorProfileCredentials;
class SnowflakeConnectorProfileCredentials {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SnowflakeConnectorProfileCredentials = SnowflakeConnectorProfileCredentials;
class ZendeskConnectorProfileCredentials {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ZendeskConnectorProfileCredentials = ZendeskConnectorProfileCredentials;
class SnowflakeConnectorProfileProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SnowflakeConnectorProfileProperties = SnowflakeConnectorProfileProperties;
class SalesforceConnectorProfileProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SalesforceConnectorProfileProperties = SalesforceConnectorProfileProperties;
class ConnectorProfileConfig {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ConnectorProfileConfig = ConnectorProfileConfig;
class AmplitudeConnectorProfileCredentials {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.AmplitudeConnectorProfileCredentials = AmplitudeConnectorProfileCredentials;
class ConnectorOAuthRequest {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ConnectorOAuthRequest = ConnectorOAuthRequest;
class DatadogConnectorProfileCredentials {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DatadogConnectorProfileCredentials = DatadogConnectorProfileCredentials;
class SlackConnectorProfileCredentials {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SlackConnectorProfileCredentials = SlackConnectorProfileCredentials;
class TrendmicroConnectorProfileCredentials {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.TrendmicroConnectorProfileCredentials = TrendmicroConnectorProfileCredentials;
class VeevaConnectorProfileCredentials {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VeevaConnectorProfileCredentials = VeevaConnectorProfileCredentials;
class VeevaConnectorProfileProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.VeevaConnectorProfileProperties = VeevaConnectorProfileProperties;
class SlackConnectorProfileProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.SlackConnectorProfileProperties = SlackConnectorProfileProperties;
class MarketoConnectorProfileProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.MarketoConnectorProfileProperties = MarketoConnectorProfileProperties;
class InforNexusConnectorProfileCredentials {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.InforNexusConnectorProfileCredentials = InforNexusConnectorProfileCredentials;
class DatadogConnectorProfileProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.DatadogConnectorProfileProperties = DatadogConnectorProfileProperties;
class ServiceNowConnectorProfileProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ServiceNowConnectorProfileProperties = ServiceNowConnectorProfileProperties;
class ConnectorProfileProperties {
    constructor(properties) {
        Object.assign(this, properties);
    }
}
exports.ConnectorProfileProperties = ConnectorProfileProperties;
class ConnectorProfile extends resource_1.ResourceBase {
    constructor(properties) {
        super('AWS::AppFlow::ConnectorProfile', properties);
    }
}
exports.default = ConnectorProfile;
ConnectorProfile.InforNexusConnectorProfileProperties = InforNexusConnectorProfileProperties;
ConnectorProfile.DynatraceConnectorProfileCredentials = DynatraceConnectorProfileCredentials;
ConnectorProfile.MarketoConnectorProfileCredentials = MarketoConnectorProfileCredentials;
ConnectorProfile.RedshiftConnectorProfileCredentials = RedshiftConnectorProfileCredentials;
ConnectorProfile.ZendeskConnectorProfileProperties = ZendeskConnectorProfileProperties;
ConnectorProfile.GoogleAnalyticsConnectorProfileCredentials = GoogleAnalyticsConnectorProfileCredentials;
ConnectorProfile.DynatraceConnectorProfileProperties = DynatraceConnectorProfileProperties;
ConnectorProfile.SalesforceConnectorProfileCredentials = SalesforceConnectorProfileCredentials;
ConnectorProfile.RedshiftConnectorProfileProperties = RedshiftConnectorProfileProperties;
ConnectorProfile.ConnectorProfileCredentials = ConnectorProfileCredentials;
ConnectorProfile.SingularConnectorProfileCredentials = SingularConnectorProfileCredentials;
ConnectorProfile.ServiceNowConnectorProfileCredentials = ServiceNowConnectorProfileCredentials;
ConnectorProfile.SnowflakeConnectorProfileCredentials = SnowflakeConnectorProfileCredentials;
ConnectorProfile.ZendeskConnectorProfileCredentials = ZendeskConnectorProfileCredentials;
ConnectorProfile.SnowflakeConnectorProfileProperties = SnowflakeConnectorProfileProperties;
ConnectorProfile.SalesforceConnectorProfileProperties = SalesforceConnectorProfileProperties;
ConnectorProfile.ConnectorProfileConfig = ConnectorProfileConfig;
ConnectorProfile.AmplitudeConnectorProfileCredentials = AmplitudeConnectorProfileCredentials;
ConnectorProfile.ConnectorOAuthRequest = ConnectorOAuthRequest;
ConnectorProfile.DatadogConnectorProfileCredentials = DatadogConnectorProfileCredentials;
ConnectorProfile.SlackConnectorProfileCredentials = SlackConnectorProfileCredentials;
ConnectorProfile.TrendmicroConnectorProfileCredentials = TrendmicroConnectorProfileCredentials;
ConnectorProfile.VeevaConnectorProfileCredentials = VeevaConnectorProfileCredentials;
ConnectorProfile.VeevaConnectorProfileProperties = VeevaConnectorProfileProperties;
ConnectorProfile.SlackConnectorProfileProperties = SlackConnectorProfileProperties;
ConnectorProfile.MarketoConnectorProfileProperties = MarketoConnectorProfileProperties;
ConnectorProfile.InforNexusConnectorProfileCredentials = InforNexusConnectorProfileCredentials;
ConnectorProfile.DatadogConnectorProfileProperties = DatadogConnectorProfileProperties;
ConnectorProfile.ServiceNowConnectorProfileProperties = ServiceNowConnectorProfileProperties;
ConnectorProfile.ConnectorProfileProperties = ConnectorProfileProperties;
